/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ProtectedAwsWorkloadsContext } from '../contexts/ProtectedAwsWorkloadsContext';

export const useProtectedAwsWorkloadsStore = () => useContext(ProtectedAwsWorkloadsContext);
